module.exports = __webpack_public_path__ + "static/media/galerija_2019 (26).4e3fd465.jpg";